function logAnalytics(
  eventTypeLabel: string,
  eventTypeColor: string,
  eventName: string,
  properties: unknown,
  options: SegmentAnalytics.SegmentOpts,
): void {
  console.groupCollapsed(
    `%cAnalytics%c${eventTypeLabel}%c ${eventName}`,
    `
      background-color: #3BB273;
      color: white;
      font-weight: bold;
      padding: 1px 4px 1px 4px;
      border-radius: 3px 0 0 3px;
    `,
    `
      background-color: ${eventTypeColor};
      color: white;
      font-weight: bold;
      padding: 1px 4px 1px 4px;
      border-radius: 0 3px 3px 0;
    `,
    `
      font-weight: normal;
    `,
  );

  if (properties instanceof Object) {
    // Checking here to make Eslint happy. It doesn't like any type or Object type
    Object.entries(properties).forEach(([key, value]) => {
      console.info(`%c${key}: %o`, "color:grey", value);
    });
  }

  console.info("%coptions: %o", "color:grey", options);

  console.groupEnd();
}

export default function setupAnalyticsConsoleLogger(
  analyticsLibrary: SegmentAnalytics.AnalyticsJS,
): void {
  if (!analyticsLibrary || typeof analyticsLibrary.on !== "function") {
    return;
  }

  analyticsLibrary.on("group", (id: string, properties, options) => {
    logAnalytics("Group", "#DD9639", id, properties, options);
  });
  analyticsLibrary.on("identify", (id: string, properties, options) => {
    logAnalytics("Identify", "#DD9639", id, properties, options);
  });
  // The signature of this event is (event, properties, options) and it's wrong
  // There is an optional categoryName ast the first property
  // eslint-disable-next-line
  // @ts-ignore
  analyticsLibrary.on("page", (_, pageName, properties, options) => {
    logAnalytics("Page View", "#A55CA8", pageName, properties, options);
  });
  analyticsLibrary.on("track", (eventName: string, properties, options) => {
    logAnalytics("Track", "#438BC6", eventName, properties, options);
  });
}
